module.exports = __webpack_public_path__ + "odinstatic/media/pod.cbb0a7b1.svg";